import { UIMatch, generatePath } from 'react-router'

import { CsRoute } from './types'
import { Link } from '@mui/material'
import { prepareRoutes } from './utils/prepareRoutes'
import { routePaths } from './route-paths'

export const useProviderFileTransferRoutes = () => {
	const routes = prepareRoutes([useProviderFtpConfigurations(), useProviderEncryptionConfigurations()], {
		stripLeading: `${routePaths.benefitProviders.edit.fileTransfer.path}/`,
	})

	return routes
}

export const useProviderFtpConfigurations = (): CsRoute => {
	return {
		path: routePaths.benefitProviders.edit.fileTransfer.ftpConfigurations.path,
		handle: {
			crumb: (data: UIMatch<any, any>) => (
				<Link
					href={generatePath(routePaths.benefitProviders.edit.fileTransfer.ftpConfigurations.path, {
						id: data.params.id ?? '',
					})}
				>
					FTP Configurations
				</Link>
			),
		},
		lazy: () =>
			import('pages/benefit-providers').then((module) => ({
				Component: module.BenefitProviderFtpConfigurations,
			})),
	}
}

export const useProviderEncryptionConfigurations = (): CsRoute => {
	return {
		path: routePaths.benefitProviders.edit.fileTransfer.encryptionConfigs.path,
		handle: {
			crumb: (data: UIMatch<any, any>) => (
				<Link
					href={generatePath(routePaths.benefitProviders.edit.fileTransfer.encryptionConfigs.path, {
						id: data.params.id ?? '',
					})}
				>
					Encryption Settings
				</Link>
			),
		},
		lazy: () =>
			import('pages/benefit-providers').then((module) => ({
				Component: module.BenefitProviderEncryptionConfigs,
			})),
	}
}
